import { ChangeDetectionStrategy, Component, inject, Input } from '@angular/core';
import { RoutingService } from '../../../../../services/routing.service';
import { HoldingDiscriminator } from '../../../../enums/HoldingDiscriminator.enum';
import { UnitBankAccountReqRes } from '../../../../models/gp/UnitBankAccountReqRes.model';
import { PaymentReadDto } from '../models/payment/payment-read-dto.model';
import { UnitPaymentService } from '../unit-payment.service';

@Component({
  selector: 'terra-unit-payment-sender-details',
  templateUrl: './unit-payment-sender-details.component.html',
  styleUrls: ['./unit-payment-sender-details.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class UnitPaymentSenderDetailsComponent {
  @Input() payment: PaymentReadDto;
  @Input() sourceBankAccount: UnitBankAccountReqRes;

  private readonly paymentService = inject(UnitPaymentService);
  private readonly routingService = inject(RoutingService);

  /**
   * Concat sender first name and last name
   */
  get senderName() {
    if (!!this.sourceBankAccount && !!this.sourceBankAccount.unitApplication && !!this.sourceBankAccount.unitApplication.contact) {
      return `${this.sourceBankAccount.unitApplication.contact.fullName.first} ${this.sourceBankAccount.unitApplication.contact.fullName.last}`;
    }

    return '';
  }

  get linkToBankAccountPage(): string {
    if (this.paymentService.isGp) {
      return this.routingService.creBankAccountPage(this.sourceBankAccount.id);
    }
    else {
      return this.routingService.lpUnitBankAccount(this.sourceBankAccount.id);
    }
  }

  get linkToHolding(): string {
    if (!!this.sourceBankAccount?.unitApplication?.holding) {
      const holding = this.sourceBankAccount.unitApplication.holding;
      if (holding.discriminator === HoldingDiscriminator.Asset) {
        return this.routingService.gpAssetPage(holding.id);
      } else {
        return this.routingService.gpFundPage(holding.id);
      }
    }

    return '';
  }
}
